import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { WaterfalldetailsArrayModel, WaterfalldetailsModel } from "../../models/WaterfallDetailsModel";

const initialWaterfallDetailsState: WaterfalldetailsArrayModel = {
    waterfall_details: [],
    isFetching: false
}

const WaterfallDetailsSlice = createSlice({
    name: "WaterfallDetails",
    initialState: initialWaterfallDetailsState,
    reducers: {
        setWaterFallDetails(state, action: PayloadAction<WaterfalldetailsModel[]>) {
            state.waterfall_details = action.payload
        },
        setWaterFallDetailsFetching(state, action: PayloadAction<boolean>) {
            state.isFetching = action.payload;
        },
    },


})

export default WaterfallDetailsSlice